export const MOBILE_DISPLAY_WIDTH = 480;
export const MEDIA_PROJECTS = 'media_projects';
export const ILLUSTRATION = 'illustration';
export const DESIGN = 'design';
export const ABOUT = 'about';
export const PHOTOGRAPHY = 'photography';
export const FINE_ART = 'fine_art';
export const CONTACTS = 'contacts';

export const ROUTES = {
  mediaProjects: 'media_projects',
  illustration: 'illustration',
  design: 'design',
  about: 'about',
  photography: 'photography',
  fineArt: 'fine_art',
  contacts: 'contacts',
};
